export default __webpack_public_path__ + "static/media/TopBarOrder.15e82cdf.svg";